import React from "react";
import "./medical-report-editor-dialog.scss";
import { ErrorSessionNotFound, ErrorRequestConstructor } from "../../../services/ConclusionConstructor/index.ts";

import { Spinner } from "../../state-indicators/index.js";

class MedicalReportEditorDialog extends React.Component {
    constructor(props) {
        super(props);
        this.refDiagnosis = React.createRef();
    }
    state = {
        medicalConclusion: "",
        autoConclusion: "",
        constructorAvailable: true, // Доступность функционала с конструктором
        constructorEnable: true, // Возможность воспользоваться конструктором
        constructorErrorText: null
    };

    componentDidMount() {
        const { data } = this.props;
        if (!data) {
            return;
        }
        const { medicalConclusion, autoConclusion } = data;
        this.setState({ medicalConclusion: medicalConclusion ?? "", autoConclusion: autoConclusion ?? "" });
    }

    componentWillUnmount() {
        this.props.conclusionService.StopWaitAnswer();
    }

    onSubmit = e => {
        e.preventDefault();

        const { onSave, onClose } = this.props;
        onSave({ medicalConclusion: this.input.innerHTML });
        onClose();
    };

    onClose = () => {
        this.props.onClose({
            medicalConclusion: this.input.innerHTML,
            autoConclusion: this.state.autoConclusion
        });
    };

    onCancel = () => this.props.onClose();

    onResetToAutomatic = () => {
        this.setState(preState => ({ medicalConclusion: preState.autoConclusion, constructorErrorText: "" }));
        // this.refDiagnosis.current.callClearAll();
    };

    // onChooseDiagnosis = text => {
    //     if (!text) {
    //         return;
    //     }
    //     this.input.innerHTML = this.input.innerHTML + text.last + "<br/>"; // Манипуляция напрямую минуя state, чтобы компонент не перерисовывался и не терял фокус
    // };

    onOpenConstructorClicked = async () => {
        const { data, loc, conclusionService } = this.props;
        if (!data || !this.state.constructorAvailable) {
            return;
        }
        const {
            representativeCmpx: {
                S,
                angles,
                QTmax,
                QTc,
                P,
                RR,
                PDur,
                STDeprTo_uV,
                STDeprTo_Lead,
                STElevTo_uV,
                STElevTo_Lead,
                transZone,
                indexSokolovLyon
            },
            patient: { sex, birthday },
            stimulatorType,
            exam_date,
            RRParams: { RRavg, RRmin, RRmax, HR }
        } = data;
        try {
            this.setState({ constructorErrorText: null, constructorEnable: false });
            const check = val => !(isNaN(val) || val === undefined || val === null);
            const constrData = {
                Sex: sex === "M" ? "Male" : sex === "F" ? "Female" : null,
                BirthDate: birthday ? birthday.split(".").reverse().join("-") : "",
                ExaminationDate: exam_date ? exam_date.split(".").reverse().join("-") : "",
                RRmean: RRavg?.val,
                RRmin: RRmin?.val,
                RRmax: RRmax?.val,
                QRSduration: S?.val,
                AlphaAngle: angles.QRS.val,
                QTduration: QTmax?.val,
                PQduration: check(P.val) ? -P.val : null,
                Pduration: PDur.val,
                STdepression: check(STDeprTo_uV?.val) && Math.abs(STDeprTo_uV.val) > 100 ? [STDeprTo_Lead.val] : null,
                STelevation: check(STElevTo_uV?.val) && Math.abs(STElevTo_uV.val) > 100 ? [STElevTo_Lead.val] : null,
                TransitionZone: transZone?.val,
                SokolowLyonIndex: check(indexSokolovLyon?.val) ? Math.round(indexSokolovLyon?.val * 10) : null,

                Stimulus: stimulatorType,
                HR: HR?.val,
                RR: RR?.val,
                QTc: QTc?.val
            };
            const session_id = await conclusionService.openConstructor(constrData);
            await conclusionService.StartWaitAnswer(session_id).then(text => {
                if (text) {
                    // Remove \r\n from start/end
                    text = text.replace(/^(\\r\\n|\\n|\\r)+|(\\r\\n|\\n|\\r)+$/g, "");
                    // Replace \r\n with <br/> in other cases
                    text = text.replace(/(\\r\\n|\\n|\\r)+/g, "<br/>");

                    this.setState(prev => ({ medicalConclusion: prev.medicalConclusion + text + "<br/>" })); // text.replaceAll("\\r\\n", "<br/>")
                }
            });
        } catch (err) {
            if (err instanceof ErrorSessionNotFound) {
                console.error("Wrong report constructor session ID.");
            } else if (err instanceof ErrorRequestConstructor) {
                console.error("Unspecified report constructor error.");
            } else {
                console.error("Unspecified report constructor error.");
            }
            this.setState({ constructorErrorText: loc("errors.constructor.common") });
        } finally {
            this.setState({ constructorEnable: true });
        }
    };

    render() {
        const {
            loc,
            data: { useExternalConclusionConstructor }
        } = this.props;
        const { medicalConclusion, constructorAvailable, constructorEnable } = this.state;
        return (
            <div id="medRep-popup-window" className="popup-window popup-window_opened medRep-popup-window">
                <button type="button" className="popup-close-btn" onClick={() => this.onClose()}>
                    &times;
                </button>
                <form className="medRep-form" action="#" onSubmit={this.onSubmit}>
                    <h3 className="form-header">{loc("dialogs.editConclusion.title")}</h3>

                    <div className="form-content">
                        {/* <div style={{ display: "flex" }}>
                                <Diagnosis
                                    className="scroll-styled"
                                    onResultTextChanged={this.onChooseDiagnosis}
                                    onReset={this.onResetToAutomatic}
                                    ref={this.refDiagnosis}
                                />
                            </div> */}

                        <div>
                            <div
                                className="medical-report ctrl-input scroll-styled"
                                contentEditable
                                dangerouslySetInnerHTML={{ __html: medicalConclusion }}
                                key={Date.now()}
                                ref={el => (this.input = el)}
                                disabled={!constructorEnable}
                            />
                            {!constructorEnable && <Spinner small transparent={false} />}
                        </div>
                    </div>

                    <div className="form-footer" style={{}}>
                        {/* <div>
                                <button
                                    type="button"
                                    className="button"
                                    value={loc("dialogs.intervalSelector.resetAuto")}
                                    title={loc("dialogs.intervalSelector.resetAutoComment")}
                                    onClick={this.onResetToAutomatic}>
                                    Очистить
                                    <SvgEraser />
                                </button>
                                <button
                                    type="button"
                                    className="button"
                                    onClick={() => {
                                        this.refDiagnosis.current.callResetCodes();
                                    }}>
                                    Новый ритм <SvgPlus />
                                </button>
                            </div> */}

                        <div>
                            {constructorAvailable && useExternalConclusionConstructor ? (
                                <>
                                    <button
                                        disabled={!constructorEnable}
                                        type="button"
                                        className="button"
                                        title={loc("dialogs.editConclusion.openConstructor")}
                                        onClick={this.onOpenConstructorClicked}>
                                        {loc("dialogs.editConclusion.openConstructor_btnText")}
                                    </button>
                                </>
                            ) : (
                                <button
                                    type="button"
                                    className="button"
                                    value={loc("dialogs.intervalSelector.resetAuto")}
                                    title={loc("dialogs.intervalSelector.resetAutoComment")}
                                    onClick={this.onResetToAutomatic}>
                                    Очистить
                                </button>
                            )}
                        </div>
                        <div>
                            <input type="submit" className="button button-ok" value={loc("buttons.ok")} />
                            <input
                                type="reset"
                                className="button button-cancel"
                                value={loc("buttons.cancel")}
                                onClick={() => this.onCancel()}
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default MedicalReportEditorDialog;
